import type { Calculations } from '@features/glossary';
import { layout, marginLeft } from '@features/lci-report/domain/dimensions';
import { theme } from '@features/lci-report/domain/theme';
import { TITLE } from '@features/lci-report/slides/shared/dark-background-slide-master';
import { contentSlideHeader } from '@features/lci-report/utils';
import { Slide, getColumnXPositions } from '@features/powerpoint';
import { SlideSection, getCalculations } from '../domain/content';
import { column } from './column';

export const page = (
  calculations: Calculations,
  pageNumber: number,
  entriesPerColumnPerPage: number[]
): Slide => {
  {
    const sections: SlideSection[] = Object.values(calculations).map(
      (section, sectionIndex) => ({
        label: section.label,
        items: getCalculations(section.items, {
          perPage: entriesPerColumnPerPage[sectionIndex] ?? 0,
          page: pageNumber,
        }),
      })
    );

    const columnPositions = getColumnXPositions(
      marginLeft,
      layout.width - 2 * marginLeft,
      sections.length,
      0.25
    );

    // If only one section has content (as it does at the time of writing), the position of the column
    // will match the previous page. This makes sense conceptually, but in practice looks strange.
    // If it is determined that the column position should be maintained, this line can be removed.
    const sectionsWithContent = sections.filter(
      section => section.items.text.length > 0
    );

    const columns = sectionsWithContent.map((section, columnIndex) =>
      column(section, {
        x: columnPositions.positions[columnIndex],
        y: 1.75,
        h: 5,
        w: columnPositions.columnWidth,
      })
    );

    return {
      slideMaster: TITLE,
      texts: [
        contentSlideHeader('Calculations', { color: theme.colors.white }),
        ...columns,
      ],
    };
  }
};
